export default "__VITE_ASSET__rZNfWTkG__"